export default __webpack_public_path__ + "static/media/fatihdurmaz.40363b65.pdf";